<template>
  <el-card>
    <template #header>
      <content-header />
    </template>

    <el-row type="flex" :gutter="20" class="row-bg mt-3" v-if="topData.keyword">
      <el-col :span="12">
        <el-card class="box-card">
          <div class="ibox float-e-margins border_left_border">
            <div class="ibox-title">
              <h5>TA自己(报单/复销)</h5>
            </div>
            <div class="ibox-content">
              <div class="pt10">报单： {{topData.self_debit_num}} 件({{topData.self_debit_amount}} 元)</div>
              <div class="pt10">复销： {{topData.self_repeat_num}} 件({{topData.self_repeat_amount}} 元)</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card class="box-card">
          <div class="ibox float-e-margins border_left_border">
            <div class="ibox-title">
              <h5>团队推荐(报单/复销)</h5>
            </div>
            <div class="ibox-content">
              <div class="pt10">报单： {{topData.team_invite_debit_num}} 件({{topData.team_invite_debit_amount}} 元)</div>
              <div class="pt10">复销： {{topData.team_invite_repeat_num}} 件({{topData.team_invite_repeat_amount}} 元)</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card class="box-card">
          <div class="ibox float-e-margins border_left_border">
            <div class="ibox-title">
              <h5>团队安置(报单/复销)</h5>
            </div>
            <div class="ibox-content">
              <div class="pt10">报单： {{topData.team_posit_debit_num}} 件({{topData.team_posit_debit_amount}} 元)</div>
              <div class="pt10">复销： {{topData.team_posit_repeat_num}} 件({{topData.team_posit_repeat_amount}} 元)</div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-button-group class="mb-3 mt-3"><search-form :fields="search" /></el-button-group>

    <el-table :data="saleGoodsDailyStats" resource="sale-goods-daily-stats" v-loading="loading">
      <el-table-column prop="id" label="ID" width="100" />
      <el-table-column align="center" header-align="center" label="账号" width="120">
        <template slot-scope="scope">
          <div v-if="scope.row.user">
            <span>{{ scope.row.user.real_name }}({{ scope.row.user.level_name }})</span>
            <br />
            <span>{{ scope.row.user.mobile }}</span>
            <br />
            <span>{{ scope.row.user.idcard_no }}</span>
          </div>
        </template>
      </el-table-column>
      <!--      <el-table-column prop="week_tag" label="盛塘周标识" width="120"/>
      <el-table-column prop="month_tag" label="盛塘月标识" width="120"/> -->
      <el-table-column prop="stats_date" label="统计日" width="120" />
      <el-table-column label="TA自己">
        <template slot-scope="scope">
          报单：
          <span class="color-warning">{{ scope.row.self_debit_num }} 件({{ scope.row.self_debit_amount }} 元)</span>
          <br />
          复销：
          <span class="color-info">{{ scope.row.self_repeat_num }} 件({{ scope.row.self_repeat_amount }} 元)</span>
        </template>
      </el-table-column>

      <el-table-column label="团队报单数(推荐)">
        <template slot-scope="scope">
          <span class="color-warning">{{ scope.row.team_invite_debit_num }} 件({{ scope.row.team_invite_debit_amount }} 元)</span>
        </template>
      </el-table-column>

      <el-table-column label="团队复销数(推荐)">
        <template slot-scope="scope">
          <span class="color-warning">{{ scope.row.team_invite_repeat_num }} 件({{ scope.row.team_invite_repeat_amount }} 元)</span>
        </template>
      </el-table-column>

      <el-table-column label="团队报单数(安置)">
        <template slot-scope="scope">
          <span class="color-warning">{{ scope.row.team_posit_debit_num }} 件({{ scope.row.team_posit_debit_amount }} 元)</span>
        </template>
      </el-table-column>

      <el-table-column label="团队复销数(安置)">
        <template slot-scope="scope">
          <span class="color-warning">{{ scope.row.team_posit_repeat_num }} 件({{ scope.row.team_posit_repeat_amount }} 元)</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-button-group>
            <el-button @click="showByLeader(scope.row, 0)" size="small">查看TA的【推荐】团队业绩</el-button>
            <el-button @click="showByLeader(scope.row, 1)" size="small">查看TA的【安置】团队业绩</el-button>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <div class="card-footer"><pagination :page="page" /></div>

    <el-dialog :title="dialogLeadertitle" :visible.sync="dialogLeaderVisible" width="1200px" append-to-body v-loading="loading">
      <el-date-picker
        v-model="userGoodsSaleQueryData.stats_date"
        type="daterange"
        range-separator="至"
        value-format="yyyy-MM-dd"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        clearable
      ></el-date-picker>
      &nbsp;
      <el-button type="primary" @click="queryList">查询</el-button>
      <el-button type="primary" @click="queryAllList">查询所有</el-button>
      <el-divider></el-divider>
      <el-table :data="userGoodsSaleList" v-loading="loading">
        <!-- 序号	会员	统计日期	TA自己	团队报单数(推荐)	团队复销数(推荐) -->
        <el-table-column type="index" property="id" label="序号" width="50" />
        <el-table-column align="center" header-align="center" label="会员" width="150">
          <template slot-scope="scope">
            <div v-if="scope.row.user">
              <span>{{ scope.row.user.real_name }}({{ scope.row.user.level_name }})</span>
              <br />
              <span>{{ scope.row.user.mobile }}</span>
              <br />
              <span>{{ scope.row.user.idcard_no }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="stats_date" label="统计日期" width="150" />
        <el-table-column label="TA自己">
          <template slot-scope="scope">
            报单：
            <span class="color-warning">{{ scope.row.self_debit_num }} 件({{ scope.row.self_debit_amount }} 元)</span>
            <br />
            复销：
            <span class="color-info">{{ scope.row.self_repeat_num }} 件({{ scope.row.self_repeat_amount }} 元)</span>
          </template>
        </el-table-column>
        <template v-if="dimension === 0">
          <el-table-column label="团队报单数(推荐)">
            <template slot-scope="scope">
              <span class="color-warning">{{ scope.row.team_invite_debit_num }} 件({{ scope.row.team_invite_debit_amount }} 元)</span>
            </template>
          </el-table-column>

          <el-table-column label="团队复销数(推荐)">
            <template slot-scope="scope">
              <span class="color-warning">{{ scope.row.team_invite_repeat_num }} 件({{ scope.row.team_invite_repeat_amount }} 元)</span>
            </template>
          </el-table-column>
        </template>
        <template v-else>
          <el-table-column label="团队报单数(安置)">
            <template slot-scope="scope">
              <span class="color-warning">{{ scope.row.team_posit_debit_num }} 件({{ scope.row.team_posit_debit_amount }} 元)</span>
            </template>
          </el-table-column>

          <el-table-column label="团队复销数(安置)">
            <template slot-scope="scope">
              <span class="color-warning">{{ scope.row.team_posit_repeat_num }} 件({{ scope.row.team_posit_repeat_amount }} 元)</span>
            </template>
          </el-table-column>
        </template>
      </el-table>
      <div>
        <el-divider></el-divider>
        <el-pagination
          background
          @current-change="userGoodsSalePageChange"
          :current-page.sync="userGoodsSaleQueryData.current_page"
          :page-size="userGoodsSaleQueryData.per_page"
          layout="total, prev, pager, next,jumper"
          :total="userGoodsSaleQueryData.total"
        />
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import SearchForm from '@c/SearchForm';
import Pagination from '@c/Pagination';
import { getSaleGoodsDailyStats, getTopData, getUserGoodsSaleList } from '@/api/sale-goods-daily-stats';
import { getLocalData } from '@/libs/util';

export default {
  name: 'Index',
  components: {
    SearchForm,
    Pagination
  },
  data() {
    return {
      search: [
        {
          field: 'keyword',
          label: '手机号码/姓名',
        },
        {
          field: 'stats_date',
          label: '日期',
          type: 'date-picker',
        },
      ],
      saleGoodsDailyStats: [],
      page: null,
      dimension: 0, // 推荐关系->0,安置关系->1;
      loading: true,
      dialogLeaderVisible: false,
      dialogLeadertitle: '',
      userGoodsSaleList: [],
      userGoodsSalePage: {},
      userGoodsSaleQueryData: {
        parent_id: 0,
        posit_parent_id: 0,
        stats_date: [getLocalData('d'), getLocalData('d')],
        page_size: 8
      },
      query: {},
      topData: [],
      keyword: '',
    };
  },
  methods: {
    showByLeader(row, type) {
      this.dialogLeadertitle = '【'+ row.user.username + '(' + row.user.real_name + ')' + '】商品销售日统计【' + (type === 0 ? '推荐' : '安置') + '】团队业绩'
      this.dimension = type;
      this.dialogLeaderVisible = true;
      this.userGoodsSaleQueryData = {
        parent_id: this.dimension === 0 ? row.user_id : 0,
        posit_parent_id: this.dimension === 0 ? 0 : row.user_id,
        stats_date: [getLocalData('d'), getLocalData('d')],
        page_size: 8
      };
      this.getUserGoodsSaleList();
    },
    async queryList() {
      this.getUserGoodsSaleList();
    },
    async queryAllList() {
      this.userGoodsSaleQueryData.stats_date = [];
      this.getUserGoodsSaleList();
    },
    async getUserGoodsSaleList() {
      this.loading = true;
      const {
        data: { data, meta }
      } = await getSaleGoodsDailyStats(this.userGoodsSaleQueryData);
      this.userGoodsSaleList = data;
      this.userGoodsSalePage = meta;
      this.loading = false;
    },
    userGoodsSalePageChange(val) {
      this.userGoodsSaleQueryData.page = val;
      this.getUserGoodsSaleList();
    },
    async getTopData(query) {
      const {data} = await getTopData(query);
      this.topData = data;
    },
  },
  watch: {
    $route: {
      async handler(newVal) {
        this.query = newVal.query;
        const {
          data: { data, meta }
        } = await getSaleGoodsDailyStats(this.query);
        this.saleGoodsDailyStats = data;
        this.page = meta;
        this.loading = false;
        this.getTopData(this.query);
      },
      immediate: true
    }
  }
};
</script>
<style lang="scss" scoped>
  .ibox {
    clear:both;
    margin-top:0;
    padding:0;
  }
  .ibox-title {
    -moz-border-bottom-colors:none;
    -moz-border-left-colors:none;
    -moz-border-right-colors:none;
    -moz-border-top-colors:none;
    background-color:#ffffff;
    border-color:#e7eaec;
    border-image:none;
    border-width:1px 0 0;
    margin-bottom:0;
  }
  .ibox-content {
    background-color:#ffffff;
    padding-top:5px;
    border-color:#e7eaec;
    border-image:none;
    border-style:solid solid none;
    border-width:1px 0;
  }
  .pt10 {
    padding-top: 10px;
    font-size: 13px;
  }
  .pull-right {
    float: right !important;
  }
  .no-margins {
    margin: 0 !important;
    color: #606266;
  }
  .label-primary, .badge-primary {
    background-color: #1ab394;
    color: #FFFFFF;
  }
  .label {
    background-color: #409EFF;
    color: #fff;
    font-size: 10px;
    font-weight: 600;
    padding: 3px 8px;
    text-shadow: none;
    border-radius: 0.25em;
  }
</style>
